import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Settings } from '../settings';

@Injectable()

export class TeamService {

  private contentHeadersJson: HttpHeaders;
  private baseUrl: string;

  constructor(
    private http: HttpClient
  ) {
    this.baseUrl = Settings.baseUrlBackend;
    this.ini();
  }

  // Métodos generales
  public ini(): void {
  }

  getTeams(): Observable<any> {
    const url = this.baseUrl + '/rest/core/servicios/obtenerEquipos';
    const body = {};
    const options = { headers: this.contentHeadersJson };

    const request: Observable<any> = this.http.post(url, body, options);
    return request;
  }
}
